import {useEffect} from 'react'
import {useRelayCachePreheatContext} from '../contexts/RelayCachePreheatContext'
import type {ConcreteRequest, GraphQLTaggedNode} from 'relay-runtime'

type UseCachePreheatQueryProps = {
  query?: GraphQLTaggedNode
  variables: Record<string, unknown>
  source: string
  enabled: boolean
}

export function useCachePreheatQuery({query, variables, source, enabled}: UseCachePreheatQueryProps) {
  const {markQueryForPreheating} = useRelayCachePreheatContext()

  useEffect(() => {
    if (!enabled || !query) {
      return
    }
    markQueryForPreheating(query as ConcreteRequest, variables, source)
  }, [markQueryForPreheating, variables, query, source, enabled])
}
